import { render, staticRenderFns } from "./TaskFormatsForm.vue?vue&type=template&id=3441d0d2"
import script from "./TaskFormatsForm.vue?vue&type=script&lang=js"
export * from "./TaskFormatsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports